import { m8API } from 'services/production/m8';
import { PayDebitService } from 'types/services';

export const payDebit: PayDebitService = async (params) => {
  await m8API.admin.payDebitManual({
    idDebit: params.debitId,
    idUser: params.clientId,
  });
};
